// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__36J3S","total":"Cart_total__345ol","actions":"Cart_actions__2tx7x","button--alt":"Cart_button--alt__1m-zz","button":"Cart_button__2sPiw"};